module.exports = __webpack_public_path__ + "static/media/christopher_farmers_market.7ab814c7.jpeg";